export default __webpack_public_path__ + "static/media/coursera.b778ed6d.png";